import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ServiceDetailLayout from "../components/ServiceDetailLayout";
import banner1 from "../assets/paye.png";
import { IoMdCheckmark, IoMdAlarm, IoMdDocument } from "react-icons/io";
import Footer from "../ones/Footer";
import TestimonialSlider from "../ones/TestimonialSlider";

export default function PAYE() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  const hero = {
    kicker: "Tax Compliance",
    title: "PAYE (Pay As You Earn)",
    subtitle: "Payroll withholding, reconciliation, and filing",
    description:
      "We streamline the PAYE workflow—data capture, validation, and submission—so your team stays focused on payroll while we keep TRA happy.",
    image: banner1,
    chips: ["Payroll precision", "Monthly filing", "Audit ready"],
  };

  const highlights = [
    { icon: <IoMdCheckmark />, title: "Accurate calculations", detail: "Automated gross-to-net reviews with tax element visibility." },
    { icon: <IoMdAlarm />, title: "Deadline guarantee", detail: "Returns compiled before the 7th and paid on your behalf." },
    { icon: <IoMdDocument />, title: "Audit confidence", detail: "Documented submission evidence and reconciliation notes." },
  ];

  const timeline = [
    { title: "Collect & validate", detail: "Gather payroll inputs, validate employee data, and capture changes." },
    { title: "Compute & review", detail: "Apply PAYE brackets, reconcile deductions, and surface anomalies." },
    { title: "File & confirm", detail: "Submit to TRA, capture acknowledgments, and share dashboards." },
  ];

  const extra = {
    ctaTitle: "Need a trusted PAYE partner?",
    ctaCopy: "Call or message us to onboard your payroll and move compliance off your plate.",
  };

  return (
    <>
      <ServiceDetailLayout hero={hero} highlights={highlights} timeline={timeline} extra={extra} />
      <TestimonialSlider />
      <Footer />
    </>
  );
}
